var _classCallCheck = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/inherits");

/*
Extends queue and add necessary methods

class:
  deque
Extends:
  queue
method:
  // super
    ///private
    _sizeup

    ///public
    front
    back
    empty
    size
    clear

  // modifier
  pushBack
  pushFront
  popBack
  PopFront

  // overriding
  push -> private
  pop -> private
  compare

  //
  toString
*/
var Queue = require('./queue');
/**
 * @classdesc Class representing deque.<br>
 * deque is implemented extends queue.<br>
 * add additional method.<br>
 * pop and push method of queue is assumed as private.<br>
 * this constructor can get Queue type object.
 * @version v1.0
 */


var Deque =
/*#__PURE__*/
function (_Queue) {
  "use strict";

  _inherits(Deque, _Queue);

  function Deque() {
    _classCallCheck(this, Deque);

    return _possibleConstructorReturn(this, _getPrototypeOf(Deque).apply(this, arguments));
  }

  _createClass(Deque, [{
    key: "front",

    /**
     * Get the first element of deque.
     * @returns {boolen} the first data of deque.
     */
    value: function front() {
      return _get(_getPrototypeOf(Deque.prototype), "front", this).call(this);
    }
    /**
     * Get the last element of deque.
     * @return {*} - the last element of deque.
     */

  }, {
    key: "back",
    value: function back() {
      return _get(_getPrototypeOf(Deque.prototype), "back", this).call(this);
    }
    /**
     * Make sure the deque is empty.
     * @return {boolean} true if deque is empty.
     */

  }, {
    key: "empty",
    value: function empty() {
      return _get(_getPrototypeOf(Deque.prototype), "empty", this).call(this);
    }
    /**
     * Get the number of element in deque.
     * @return {number} the number of elements.
     */

  }, {
    key: "size",
    value: function size() {
      return _get(_getPrototypeOf(Deque.prototype), "size", this).call(this);
    }
    /**
     * Initalize the deque
     */

  }, {
    key: "clear",
    value: function clear() {
      _get(_getPrototypeOf(Deque.prototype), "clear", this).call(this);
    }
    /**
     * add data to back of deque.
     * @param {*} data - the data of deque.
     */

  }, {
    key: "pushBack",
    value: function pushBack(data) {
      this.push(data);
    }
    /**
     * add data to front of deque.
     * @param {*} data - the data of deque.
     */

  }, {
    key: "pushFront",
    value: function pushFront(data) {
      if (this._size === 0) {
        this._elements[0] = data;
        this._size = 1;
        this._begin = 0;
        this._end = 0;
      } else {
        if (this._size === this._maxSize) {
          this._sizeup();
        }

        this._begin = (this._begin - 1) % this._maxSize;
        this._elements[this._begin] = data;
        this._size += 1;
      }
    }
    /**
     * remove the last data of deque.
     * @returns {boolean} if deque is empty, return false.
     */

  }, {
    key: "popBack",
    value: function popBack() {
      if (this._size === 0) {
        return false;
      }

      if (this._size === 1) {
        this.clear();
        return true;
      }

      this._end = (this._end - 1) % this._maxSize;
      this._size -= 1;
      return true;
    }
    /**
     * remove the first data of deque.
     * @returns {boolean} if deque is empty, return false.
     */

  }, {
    key: "popFront",
    value: function popFront() {
      return this.pop();
    }
    /**
     * do not use in deque.
     * @private
     */

  }, {
    key: "pop",
    value: function pop() {
      return _get(_getPrototypeOf(Deque.prototype), "pop", this).call(this);
    }
    /**
     * do not use in deque.
     * @private
     */

  }, {
    key: "push",
    value: function push(data) {
      _get(_getPrototypeOf(Deque.prototype), "push", this).call(this, data);
    }
    /**
     * compare data of this and param in order.
     * @param {Deque} otherDeque - Deque object.
     * @returns {boolean} Make sure this and param are same.
     */

  }, {
    key: "compare",
    value: function compare(otherDeque) {
      if (!(otherDeque instanceof Deque)) {
        return false;
      }

      if (this._size !== otherDeque.size()) {
        return false;
      }

      var i = this._begin;

      for (; i !== this._end; i = (i + 1) % this._maxSize) {
        if (this._elements[i] !== otherDeque.front()) {
          return false;
        }

        otherDeque.popFront();
      }

      if (this._elements[i] !== otherDeque.front()) {
        return false;
      }

      return true;
    }
    /**
     * show information of object
     * @returns {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      var str = "Object Name: Deque\nSize: ".concat(this.size().toString()).concat("\nElements: ");
      var i = this._begin;

      for (; i !== this._end; i = (i + 1) % this._maxSize) {
        str = str.concat("\n  Sequence[").concat(i).concat(']: ').concat(this._elements[i].toString());
      }

      if (this.size() > 0) {
        str = str.concat("\n  Sequence[").concat(i).concat(']: ').concat(this._elements[i].toString());
      }

      return str;
    }
  }]);

  return Deque;
}(Queue);

module.exports = Deque;